<mat-card appearance="outlined" class="p-0" *ngIf="(vehicleKeys | async) as vehicleKeys; else loading">
    <app-vehicle-key-table [vehicleKeys]="vehicleKeys"></app-vehicle-key-table>
</mat-card>
<div class="buttons d-flex flex-row justify-content-end gap-3">
    <button [disabled]="!canCreate" mat-raised-button color="primary" (click)="handleNewReservation()">Schlüssel anlegen</button>
</div>
<ng-template #loading>
    Loading...
</ng-template>
